<div class="container" [class.collapsed]="collapsed" [class.multiselect]="widgetSelection?.widgets?.length > 1" (click)="collapsed = false" *ngIf="tProps?.length || widgetSelection?.widgets?.length">
	<div class="sizing" [class.collapsed]="collapsed && !multiSelect" *ngIf="tProps?.length">
		<ng-container *ngFor="let prop of tProps; let i = index; trackBy: trackBy;">
			<div class="divider" *ngIf="i === 2 && collapsed && !multiSelect"></div>
			<div class="item-box">
				<div class="prop-key" [hidden]="!collapsed || multiSelect">
					{{ ('WIDGET_PROP_SHORT_' + (prop.key | uppercase)) | translate | uppercase }}
				</div>
				<div class="prop-value" [hidden]="!collapsed || multiSelect">
					<span class="value">{{ prop?.value }}</span> {{ prop?.suffix }}
				</div>
				<div class="form-widget-field-size" [hidden]="collapsed && !multiSelect">
					<ie-form-field 
						[label]="('WIDGET_PROP_SHORT_' + (prop.key | uppercase)) | translate | uppercase"
						[useDataSource]="false"
						[suffix]="prop?.suffix"
					>
						<input
							type="text"
							focus-select
							[ngModel]="prop.value === '__...__' ? '...' : prop.value"
							[tabindex]="i + 1"
							(change)="onFormFieldChanged(prop.key, true, $event.target.value)"
							[attr.data-cy]="('WIDGET_PROP_SHORT_' + (prop.key | uppercase)) | translate | lowercase"
							[name]="'widget_prop_'+ prop.key "
							class="ie-form-field-styling" />
					</ie-form-field>
				</div>
			</div>
			<div *ngIf="(!collapsed || multiSelect) && prop?.key === 'xpos'" class="position-filler"></div>
			<div *ngIf="(!collapsed || multiSelect) && prop?.key === 'width'" class="lock-aspect-ratio"
				(click)="interactivityWidgetService.aspectRatioLocked = !interactivityWidgetService.aspectRatioLocked"
				[class.disabled]="interactivityWidgetService.aspectRatio <= 0">
				<i [title]="(interactivityWidgetService.aspectRatioLocked ? 'UN' : '') + 'LOCK_ASPECT_RATIO' | translate"
					class="fa"
					[ngClass]="{'fa-chain': interactivityWidgetService.aspectRatioLocked, 'fa-chain-broken': !interactivityWidgetService.aspectRatioLocked}"
				></i>
			</div>
		</ng-container>
	</div>
	<div class="multi-checkbox" [class.collapsed]="collapsed && !multiSelect" *ngIf="checkboxProps?.length && multiSelect">
		<ng-container *ngFor="let prop of checkboxProps; let i = index; trackBy: trackBy;">
			<div class="item-box">
				<bb-form-element class="ie-checkbox" [hidden]="collapsed && !multiSelect" [postLabel]="(prop.key | uppercase) | translate | uppercase">
						<bb-check [(ngModel)]="prop.value"
							[tabindex]="i + 1" [partial]="prop.value === '__...__' ? true : false"
							(click)="multiWidgetChange(prop.key, prop.value === '__...__')"
							[name]="prop.key" [theme]="'dark-theme'"
							[trueValue]="'true'" [falseValue]="'false'" class="small">			
					</bb-check>
				</bb-form-element>
			</div>
		</ng-container>
	</div>
	<ng-container *ngIf="selectedWidget?.type === 'custom'">
		<div class="form-widget-field" *ngIf="mayRender('customJavascriptUrl')">
			<ie-form-field 
				[label]="'CUSTOM_JAVASCRIPT_URL' | translate"
				[useDataSource]="false">
				<input
					type="text"
					[(ngModel)]="selectedWidget.config.customJavascriptUrl"
					(change)="onFormFieldChanged('customJavascriptUrl')"
					[name]="'custom_widget_customJavascriptUrl'"
					tabindex="5"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.customJavascriptUrl">
			{{ 'CUSTOM_JAVASCRIPT_URL' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.customJavascriptUrl }}
		</div>
		<div class="form-widget-field" *ngIf="mayRender('widgetClassName')">
			<ie-form-field 
				[label]="'WIDGET_CLASS_NAME' | translate"
				[useDataSource]="false">
				<input
					type="text"
					[(ngModel)]="selectedWidget.config.widgetClassName"
					(change)="onFormFieldChanged('widgetClassName')"
					[name]="'custom_widget_widgetClassName'"
					tabindex="6"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.widgetClassName">
			{{ 'WIDGET_CLASS_NAME' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.widgetClassName }}
		</div>
		<div class="form-widget-field" *ngIf="mayRender('customconfig')">
			<ie-form-field 
				[label]="'CUSTOM_CONFIG' | translate"
				[useDataSource]="false">
				<textarea
					[(ngModel)]="selectedWidget.config.customconfig"
					rows="8"
					(change)="onFormFieldChanged('customconfig')"
					[name]="'custom_widget_customconfig'"
					tabindex="7"
					class="ie-form-field-styling"></textarea>
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.customconfig">
			{{ 'CUSTOM_CONFIG' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.customconfig }}
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'timer'">
		<div class="form-widget-field" *ngIf="mayRender('delay')">
			<ie-form-field 
				[label]="'DELAY' | translate"
				[useDataSource]="false">
				<input
					type="text"
					[(ngModel)]="selectedWidget.config.delay"
					(change)="onFormFieldChanged('delay')"
					[name]="'timer_widget_delay'"
					tabindex="8"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.delay">
			{{ 'DELAY' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.delay }}
		</div>
		<div class="form-widget-field" *ngIf="mayRender('repeatCount')">
			<ie-form-field 
				[label]="'REPEAT_COUNT' | translate"
				[useDataSource]="false">
				<input
					type="text"
					[(ngModel)]="selectedWidget.config.repeatCount"
					(change)="onFormFieldChanged('repeatCount')"
					[name]="'timer_widget_repeatCount'"
					tabindex="9"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.repeatCount">
			{{ 'REPEAT_COUNT' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.repeatCount }}
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'chapter'">
		<div class="form-widget-field" *ngIf="mayRender('title')">
			<ie-form-field 
				[label]="'TITLE' | translate"
				[useDataSource]="false">
				<input
					type="text"
					[(ngModel)]="selectedWidget.config.title"
					(change)="onFormFieldChanged('title')"
					[name]="'chapter_widget_title'"
					tabindex="10"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.title">
			{{ 'TITLE' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.title }}
		</div>
		<div class="form-widget-field" *ngIf="mayRender('description')">
			<ie-form-field 
				[label]="'DESCRIPTION' | translate"
				[useDataSource]="false">
				<textarea
					type="text"
					rows="5"
					[(ngModel)]="selectedWidget.config.description"
					(change)="onFormFieldChanged('description')"
					[name]="'chapter_widget_description'"
					tabindex="11"
					class="ie-form-field-styling"></textarea>
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.description">
			{{ 'DESCRIPTION' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.description }}
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'audio'">
		<ng-container *ngTemplateOutlet="itemField; context: {prop: {key: 'clipid', label: 'AUDIO'}, widget: selectedWidget, filterSet: [{'filters': [{'type': 'mediaclip', 'field': 'mediatype', 'operator': 'is', 'value': 'audio'}]}]}"></ng-container>
		<div class="form-widget-field" *ngIf="mayRender('volume')">
			<ie-form-field 
				[label]="'VOLUME' | translate"
				[useDataSource]="true"
				(dataSourceClicked)="onDataSourceClicked('volume')"
				[dataSourceActive]="selectedWidget?.config?.volume?.datasource">
				<input
					*ngIf="!selectedWidget?.config?.volume?.datasource"
					type="text"
					[(ngModel)]="selectedWidget.config.volume"
					(change)="onFormFieldChanged('volume')"
					[name]="'audio_widget_volume'"
					tabindex="12"
					class="ie-form-field-styling" />
				<input
					*ngIf="selectedWidget?.config?.volume?.datasource?.sourceType"
					type="text"
					[(ngModel)]="selectedWidget.config.volume.datasource.defaultValue"
					(change)="onFormFieldChanged('volume')"
					[name]="'audio_widget_volume'"
					tabindex="12"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.volume">
			{{ 'VOLUME' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.volume }}
		</div>
		<bb-form-element class="ie-checkbox" *ngIf="mayRender('loop')" [postLabel]="'LOOP' | translate">
			<bb-check [(ngModel)]="selectedWidget.config.loop" name="audio_widget_loop"
			(onChanged)="onFormFieldChanged('loop')"
			tabindex="13" [theme]="'dark-theme'"
			[trueValue]="'true'" [falseValue]="'false'" class="small"></bb-check>
		</bb-form-element>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.loop === 'true'">
			{{ 'LOOP' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.loop }}
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'video'">
		<ng-container *ngTemplateOutlet="itemField; context: {prop: {key: 'clipid', label: 'VIDEO'}, widget: selectedWidget, filterSet: [{'filters': [{'type': 'mediaclip', 'field': 'mediatype', 'operator': 'is', 'value': 'video'}]}]}"></ng-container>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'image'">
		<ng-container *ngFor="let prop of [{key: 'imageid', label: 'IMAGE'}, {key: 'imageid_mouseover', label: 'MOUSEOVER'}, {key: 'imageid_mousedown', label: 'ACTIVE'}, {key: 'imageid_toggle', label: 'TOGGLED'}]; trackBy: trackBy;">
			<ng-container *ngTemplateOutlet="itemField; context: {prop: prop, widget: selectedWidget, filterSet: [{'filters': [{'type': 'mediaclip', 'field': 'mediatype', 'operator': 'is', 'value': 'image'}]}]}"></ng-container>
		</ng-container>
	</ng-container>
			
	<ng-container *ngIf="['textLabel', 'button'].includes(selectedWidget?.type)">
		<div class="form-widget-field" *ngIf="mayRender('text')">
			<ie-form-field 
				[label]="'TEXT' | translate"
				[useDataSource]="true"
				(dataSourceClicked)="onDataSourceClicked('text')"
				[dataSourceActive]="selectedWidget?.config?.text?.datasource">
				<textarea
					*ngIf="!selectedWidget?.config?.text?.datasource"
					type="text"
					[(ngModel)]="selectedWidget.config.text"
					(change)="onFormFieldChanged('text')"
					[name]="'widget_text'"
					tabindex="16"
					class="ie-form-field-styling"
					rows="4">
				</textarea>
				<textarea
					*ngIf="selectedWidget?.config?.text?.datasource?.sourceType"
					type="text"
					[(ngModel)]="selectedWidget.config.text.datasource.defaultValue"
					(change)="onFormFieldChanged('text')"
					[name]="'widget_text'"
					tabindex="16"
					class="ie-form-field-styling"
					rows="4">
				</textarea>
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.text">
			{{ 'TEXT' | translate }} <i class="fa fa-long-arrow-right"></i> {{ (selectedWidget.config.text?.datasource?.defaultValue || selectedWidget.config.text) }} <i class="fa fa-plug" *ngIf="selectedWidget.config.text?.datasource"></i>
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'formTextField'">
		<div class="form-widget-field" *ngIf="mayRender('inputType')">
			<ie-form-field [label]="'INPUT_TYPE' | translate">
				<bb-select
					[(ngModel)]="selectedWidget.config.inputType"
					(change)="onFormFieldChanged('inputType')"
					theme="dark"
					tabindex="17"
					class="ie-form-field-styling"
				>
					<option value="text">
						{{ 'TEXT' | translate }}
					</option>
					<option value="email">
						{{ 'EMAIL_ADDRESS' | translate }}
					</option>
					<option value="number">
						{{ 'NUMBER' | translate }}
					</option>
					<option value="date">
						{{ 'DATE' | translate }}
					</option>
					<option value="tel">
						{{ 'PHONE_NUMBER' | translate }}
					</option>
				</bb-select>
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.inputType">
			{{ 'INPUT_TYPE' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.inputType }}
		</div>
	</ng-container>
	
	<ng-container *ngIf="['formTextArea', 'formTextField', 'formSelect'].includes(selectedWidget?.type)">
		<div class="form-widget-field" *ngIf="mayRender('formElementName')">
			<ie-form-field 
				[label]="'FORM_ELEMENT_NAME' | translate"
				[useDataSource]="true"
				(dataSourceClicked)="onDataSourceClicked('formElementName')"
				[dataSourceActive]="selectedWidget?.config?.formElementName?.datasource">
				<input
					*ngIf="!selectedWidget?.config?.formElementName?.datasource"
					type="text"
					[(ngModel)]="selectedWidget.config.formElementName"
					(change)="onFormFieldChanged('formElementName')"
					[name]="'form_widget_formElementName'"
					tabindex="17"
					class="ie-form-field-styling"
				/>
				<input
					*ngIf="selectedWidget?.config?.formElementName?.datasource?.sourceType"
					type="text"
					[(ngModel)]="selectedWidget.config.formElementName.datasource.defaultValue"
					(change)="onFormFieldChanged('formElementName')"
					[name]="'form_widget_formElementName'"
					tabindex="17"
					class="ie-form-field-styling"
				/>
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.formElementName">
			{{ 'FORM_ELEMENT_NAME' | translate }} <i class="fa fa-long-arrow-right"></i> {{ (selectedWidget.config.formElementName?.datasource?.defaultValue || selectedWidget.config.formElementName) }} <i class="fa fa-plug" *ngIf="selectedWidget.config.formElementName?.datasource"></i>
		</div>

		<ng-container *ngIf="selectedWidget?.config?.inputType !== 'date' && mayRender('placeHolder')">
			<div class="form-widget-field">
				<ie-form-field 
					[label]="'PLACEHOLDER_TEXT' | translate" 
					[useDataSource]="true"
					(dataSourceClicked)="onDataSourceClicked('placeHolder')"
					[dataSourceActive]="selectedWidget?.config?.placeHolder?.datasource">
					<input
						*ngIf="!selectedWidget?.config?.placeHolder?.datasource"
						type="text"
						[(ngModel)]="selectedWidget.config.placeHolder"
						(change)="onFormFieldChanged('placeHolder')"
						[name]="'form_widget_placeholder'"
						tabindex="18"
						class="ie-form-field-styling"
					/>
					<input
						*ngIf="selectedWidget?.config?.placeHolder?.datasource?.sourceType"
						type="text"
						[(ngModel)]="selectedWidget.config.placeHolder.datasource.defaultValue"
						(change)="onFormFieldChanged('placeHolder')"
						[name]="'form_widget_placeholder'"
						tabindex="18"
						class="ie-form-field-styling"
					/>
				</ie-form-field>
			</div>
		</ng-container>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.placeHolder">
			{{ 'PLACEHOLDER_TEXT' | translate }} <i class="fa fa-long-arrow-right"></i> {{ (selectedWidget.config.placeHolder?.datasource?.defaultValue || selectedWidget.config.placeHolder) }} <i class="fa fa-plug" *ngIf="selectedWidget.config.placeHolder?.datasource"></i>
		</div>

		<ng-container *ngIf="mayRender('options') && selectedWidget?.type === 'formSelect'">
			<ie-form-field class="form-widget-field field-options" [label]="'OPTIONS' | translate">
				<bb-label-code-list [(ngModel)]="selectedWidget.config.options"
					(ngModelChange)="onFormFieldChanged('options')"
					theme="dark" name="form_select_widget_options" [withPreview]="true"></bb-label-code-list>
			</ie-form-field>
		</ng-container>

		<div *ngIf="mayRender('value') && ['formTextArea', 'formTextField', 'formSelect'].includes(selectedWidget?.type)" class="form-widget-field" [title]="selectedWidget.config.value">
			<ie-form-field
				[label]="'VALUE' | translate"
				[useDataSource]="true"
				(dataSourceClicked)="onDataSourceClicked('value')"
				[dataSourceActive]="selectedWidget?.config?.value?.datasource">
				<!-- formSelect -->
				<ng-container *ngIf="selectedWidget?.type === 'formSelect'">
					<bb-select
						*ngIf="!selectedWidget?.config?.value?.datasource"
						[placeholder]="selectedWidget.config.placeHolder?.datasource?.defaultValue || selectedWidget.config.placeHolder || ((!selectedWidget.config.options?.length ? 'ADD_OPTIONS_FIRST' : 'SELECT...') | translate)"
						[options]="selectedWidget.config.options"
						[(ngModel)]="selectedWidget.config.value"
						(change)="onFormFieldChanged('value')"
						[name]="'form_widget_select'"
						class="ie-form-field-styling"
						theme="dark"
						tabindex="19"
					></bb-select>
					<bb-select
						*ngIf="selectedWidget?.config?.value?.datasource?.sourceType"
						[placeholder]="selectedWidget.config.placeHolder?.datasource?.defaultValue || selectedWidget.config.placeHolder || ((!selectedWidget.config.options?.length ? 'ADD_OPTIONS_FIRST' : 'SELECT...') | translate)"
						[options]="selectedWidget.config.options"
						[(ngModel)]="selectedWidget.config.value.datasource.defaultValue"
						(change)="onFormFieldChanged('value')"
						[name]="'form_widget_select'"
						tabindex="19"
						class="ie-form-field-styling"
						theme="dark"
					></bb-select>
				</ng-container>
				<!-- formTextField -->
				<ng-container *ngIf="selectedWidget?.type === 'formTextField'">
					<ng-container *ngIf="selectedWidget?.config?.inputType === 'date'">
						<bb-datepicker type="date" 
							*ngIf="!selectedWidget?.config?.value?.datasource"
							[(ngModel)]="selectedWidget.config.value"
							(ngModelChange)="onFormFieldChanged('value')"
							[name]="'form_widget_input_date'"
							[stringFormat]="'YYYY-MM-DD'"
							class="ie-form-field-styling"
							tabindex="19"
						></bb-datepicker>
						<bb-datepicker type="date" 
							*ngIf="selectedWidget?.config?.value?.datasource?.sourceType"
							[(ngModel)]="selectedWidget.config.value.datasource.defaultValue"
							(ngModelChange)="onFormFieldChanged('value')"
							[name]="'form_widget_input_date'"
							[stringFormat]="'YYYY-MM-DD'"
							class="ie-form-field-styling"
							tabindex="19"
						></bb-datepicker>
					</ng-container>
					<ng-container *ngIf="selectedWidget?.config?.inputType !== 'date'">
						<input
							*ngIf="!selectedWidget?.config?.value?.datasource"
							[type]="selectedWidget?.config?.inputType || 'text'"
							[(ngModel)]="selectedWidget.config.value"
							(change)="onFormFieldChanged('value')"
							[name]="'form_widget_input'"
							class="ie-form-field-styling"
							tabindex="19"
						/>
						<input
							*ngIf="selectedWidget?.config?.value?.datasource?.sourceType"
							[type]="selectedWidget?.config?.inputType || 'text'"
							[(ngModel)]="selectedWidget.config.value.datasource.defaultValue"
							(change)="onFormFieldChanged('value')"
							[name]="'form_widget_input'"
							tabindex="19"
							class="ie-form-field-styling"
						/>
					</ng-container>
				</ng-container>
				<!-- formTextArea -->
				<ng-container *ngIf="selectedWidget?.type === 'formTextArea'">
					<textarea
						*ngIf="!selectedWidget?.config?.value?.datasource"
						type="text"
						[(ngModel)]="selectedWidget.config.value"
						(change)="onFormFieldChanged('value')"
						[name]="'form_widget_textarea'"
						class="ie-form-field-styling"
						tabindex="19"
						rows="4">
					</textarea>
					<textarea
						*ngIf="selectedWidget?.config?.value?.datasource?.sourceType"
						type="text"
						[(ngModel)]="selectedWidget.config.value.datasource.defaultValue"
						(change)="onFormFieldChanged('value')"
						[name]="'form_widget_textarea'"
						tabindex="19"
						class="ie-form-field-styling"
						rows="4">
					</textarea>
				</ng-container>
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.value">
			{{ 'VALUE' | translate }} <i class="fa fa-long-arrow-right"></i> {{ (selectedWidget.config.value?.datasource?.defaultValue || selectedWidget.config.value) }} <i class="fa fa-plug" *ngIf="selectedWidget.config.value?.datasource"></i>
		</div>

		<ng-container *ngIf="mayRender('validation/validation/validationMethod')">
			<div class="form-widget-field">
				<ie-form-field [label]="'VALIDATION' | translate">
					<bb-select
						[ngModel]="selectedWidget?.config?.validation?.validation?.validationMethod"
						(ngModelChange)="onValidationChanged('validationMethod', $event)"
						theme="dark"
						tabindex="21"
						class="ie-form-field-styling"
					>
						<option value="">
							{{ 'NONE' | translate }}
						</option>
						<option value="BBStandard">
							{{ 'WIDGET_FORM_VALIDATION_BB_STANDARD' | translate }}
						</option>
						<option value="customJS">
							{{ 'WIDGET_FORM_VALIDATION_CUSTOM_JS' | translate }}
						</option>
					</bb-select>
				</ie-form-field>
			</div>
		
		
			<div *ngIf="selectedWidget?.config?.validation?.validation?.validationMethod === 'BBStandard'" class="form-widget-field">
				<ie-form-field [label]="'VALIDATION_TYPE' | translate">
					<bb-select
						[ngModel]="selectedWidget?.config?.validation?.validation?.validationType"
						(ngModelChange)="onValidationChanged('validationType', $event)"
						theme="dark"
						tabindex="22"
						class="ie-form-field-styling"
					>
						<option value="mandatory">
							{{ 'MANDATORY' | translate }}
						</option>
						<option value="emailAddress" *ngIf="selectedWidget?.type !== 'formSelect' && !['number', 'date', 'tel'].includes(selectedWidget.config.inputType)">
							{{ 'EMAIL_ADDRESS' | translate }}
						</option>
					</bb-select>
				</ie-form-field>
			</div>

			<div *ngIf="selectedWidget?.config?.validation?.validation?.validationMethod === 'customJS'" class="form-widget-field">
				<ie-form-field [label]="'JAVASCRIPT_FUNCTION' | translate" [allowMaximize]="true" [useMacroSuggestions]="true" [disabledMacroHotkey]="true">
					<textarea
						[ngModel]="selectedWidget?.config?.validation?.validation?.externalValidation"
						(ngModelChange)="onValidationChanged('externalValidation', $event)"
						[name]="'form_widget_placeholder'"
						tabindex="23"
						class="ie-form-field-styling"
				></textarea>
				</ie-form-field>
			</div>
		</ng-container>
	</ng-container>
	<div class="display-value" *ngIf="collapsed && selectedWidget?.config?.validation?.validation?.validationMethod">
		{{ 'VALIDATION' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget?.config?.validation?.validation?.validationMethod }}
	</div>
	<div class="display-value" *ngIf="collapsed && selectedWidget?.config?.validation?.validation?.validationMethod && selectedWidget?.config?.validation?.validation?.validationType">
		{{ 'VALIDATION_TYPE' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget?.config?.validation?.validation?.validationType }}
	</div>
	<div class="display-value" *ngIf="collapsed && selectedWidget?.config?.validation?.validation?.externalValidation">
		{{ 'JAVASCRIPT_FUNCTION' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget?.config?.validation?.validation?.externalValidation }}
	</div>

	<ng-container *ngIf="selectedWidget?.config">
		<div class="form-widget-field" *ngIf="mayRender('cssclass')">
			<ie-form-field 
				[label]="'CSS_CLASS' | translate"
				[useDataSource]="false"
				[useMacroSuggestions]="true"
			>
				<input
					type="text"
					[(ngModel)]="selectedWidget.config.cssclass"
					(change)="onFormFieldChanged('cssclass')"
					[name]="'chapter_widget_cssclass'"
					tabindex="10"
					class="ie-form-field-styling" />
			</ie-form-field>
		</div>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.cssclass">
			{{ 'CSS_CLASS' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.cssclass }}
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'rectangle'">
		<bb-form-element class="ie-checkbox" *ngIf="mayRender('showOnMouseHover')" [postLabel]="'SHOW_ONLY_ON_MOUSEOVER' | translate">
			<bb-check [(ngModel)]="selectedWidget.config.showOnMouseHover" name="rectangle_widget_showOnMouseHover" 
			(onChanged)="onFormFieldChanged('showOnMouseHover')"
			tabindex="15" [theme]="'dark-theme'"
			[trueValue]="'true'" [falseValue]="'false'" class="small"></bb-check>
		</bb-form-element>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.showOnMouseHover === 'true'">
			{{ 'SHOW_ONLY_ON_MOUSEOVER' | translate }} <i class="fa fa-long-arrow-right"></i> true
		</div>
	</ng-container>

	<ng-container *ngIf="selectedWidget?.type === 'video'">
		<bb-form-element class="ie-checkbox" *ngIf="mayRender('showControls')" [postLabel]="'SHOW_CONTROLS' | translate">
			<bb-check [(ngModel)]="selectedWidget.config.showControls" name="showControls"
			(onChanged)="onFormFieldChanged('showControls')"
			tabindex="24" [theme]="'dark-theme'"
			[trueValue]="'true'" [falseValue]="'false'" class="small"></bb-check>
		</bb-form-element>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.showControls === 'true'">
			{{ 'SHOW_CONTROLS' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.showControls }}
		</div>
	</ng-container>
	
	<ng-container *ngIf="['app'].includes(selectedWidget?.type)">
		<ng-container *ngTemplateOutlet="itemField; context: {prop: {key: 'appid', label: 'TEMPLATE'}, entityType: 'app', widget: selectedWidget}"></ng-container>
	</ng-container>

	<ng-container *ngIf="['image', 'video', 'audio', 'textLabel', 'app'].includes(selectedWidget?.type)">
		<bb-form-element class="ie-checkbox" *ngIf="mayRender('preload')" [postLabel]="'PRELOAD' | translate">
			<bb-check [(ngModel)]="selectedWidget.config.preload" name="image_widget_preload" 
			(onChanged)="onFormFieldChanged('preload')"
			tabindex="14" [theme]="'dark-theme'"
			[trueValue]="'true'" [falseValue]="'false'" class="small"></bb-check>
		</bb-form-element>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.preload === 'true'">
			{{ 'PRELOAD' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.preload }}
		</div>
	</ng-container>

	<ng-container *ngIf="!['app', 'timer', 'audio'].includes(selectedWidget?.type) && selectedWidget">
		<bb-form-element class="ie-checkbox" *ngIf="mayRender('useAsKPI')" [postLabel]="'USE_AS_KPI' | translate">
			<bb-check [(ngModel)]="selectedWidget.config.useAsKPI" name="image_widget_useAsKPI"
			(onChanged)="onFormFieldChanged('useAsKPI')"
			tabindex="14" [theme]="'dark-theme'"
			[trueValue]="'true'" [falseValue]="'false'" class="small"></bb-check>
		</bb-form-element>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.useAsKPI === 'true'">
			{{ 'USE_AS_KPI' | translate }} <i class="fa fa-long-arrow-right"></i> {{ selectedWidget.config.useAsKPI }}
		</div>

		<bb-form-element class="ie-checkbox" *ngIf="mayRender('exposeWidgetStats')" [postLabel]="'EXPOSE_WIDGET_STATS' | translate">
			<bb-check [(ngModel)]="selectedWidget.config.exposeWidgetStats" name="exposeWidgetStats"
			(onChanged)="onFormFieldChanged('exposeWidgetStats')"
			tabindex="14" [theme]="'dark-theme'"
			[trueValue]="'true'" [falseValue]="'false'" class="small"></bb-check>
		</bb-form-element>
		<div class="display-value" *ngIf="collapsed && selectedWidget.config.exposeWidgetStats === 'true'">
			{{ 'EXPOSE_WIDGET_STATS' | translate }} <i class="fa fa-chart-line"></i> {{ selectedWidget.config.exposeWidgetStats }}
		</div>
	</ng-container>

	<div [hidden]="widgetSelection?.widgets?.length > 1" class="expand-collapse-button" (click)="collapsed = !collapsed; $event.stopPropagation()">
		<i class="fa fa-angle-{{ collapsed ? 'down' : 'up'}}"></i>
	</div>
</div>

<!-- STATES -->
<div class="states-wrapper" *ngIf="visualFields?.length">
	<div class="divider"></div>
	<ng-container *ngFor="let state of states; let i = index; trackBy: stateTrackBy">

		<bb-collapsible theme="dark"
			[title]="('IE_STATE_HEADER_' + state.name | uppercase) | translate"
			[startOpen]="statePaneOpen[state.name]"
			(opened)="onStateToggled(state.name, true)"
			(closed)="onStateToggled(state.name, false)"
			class="state"
			[attr.data-cy]="'ie-state-header-' + state.name"
			(mouseover)="interactivityEditorService.activeState = state.name;"
			(mouseout)="interactivityEditorService.activeState = 'default'"
		>
			<div class="state-fields {{ state.name }}-state {{ selectedWidget.type }}-widgettype">
				<ng-container *ngFor="let stateField of visualFields; trackBy: trackBy;">
					<div class="form-widget-field"
						*ngIf="selectedWidget.interfaceConfig[state.name][stateField.key] !== undefined"
						[style.grid-area]="stateField.shortKey"
						(ngInit)="state.name === 'default' && stateField.key.includes('font') && !selectedWidget.interfaceConfig[state.name]['textFormat/textFormat/embeddedfont'] ? fillEmbeddedFont(selectedWidget.interfaceConfig[state.name]) : ''"
						[class.has-entity-selector]="stateField.fieldConfig.itype === 'font'"
					>
						<ie-form-field
							[label]="(state.name === 'default' && ((stateField.key === 'background_alpha' && 'OPACITY' | translate) || (stateField.key === 'borderthickness' && 'WIDTH' | translate))) || stateField.label"
							[useDataSource]="false"
							[suffix]="stateField.config?.suffix"
							[hideUI]="['togglebutton', 'align', 'verticalalign'].includes(stateField.fieldConfig.itype)"
						>
							<bb-field-renderer
								theme="dark"
								[displayInline]="['togglebutton', 'align', 'verticalalign'].includes(stateField.fieldConfig.itype)"
								[cssClass]="'ie-form-field-styling'"
								[fieldConfig]="stateField.fieldConfig"
								[name]="'widget_' + stateField.key + '_' + state.name"
								[ngModel]="selectedWidget.interfaceConfig[state.name][stateField.key]"
								[slowPropagation]="true"
								(optionSelected)="onStateFormFieldOptionSelected(stateField.key, $event, state)"
								(ngModelChange)="['string', 'number'].includes(stateField.fieldConfig.itype) ? '' : onStateFormFieldChanged(stateField.key, false, $event, state)"
								(change)="['string', 'number'].includes(stateField.fieldConfig.itype) ? onStateFormFieldChanged(stateField.key, false, $event, state) : ''"
							></bb-field-renderer>
						</ie-form-field>
						<bb-button *ngIf="state?.name !== 'default'" theme="dark" [round]="true" icon="close" (click)="onStateFormFieldChanged(stateField.key, true, undefined, state, true)"></bb-button>
					</div>
				</ng-container>
			</div>
			<div class="add-state-option-button" *ngIf="state?.name !== 'default'">
				<!-- <bb-entity-selector
					*ngIf="state?.name !== 'default'"
					placeholder="Add override"
					[selectOnly]="true"
					(optionSelected)="onAddStateOptionSelected($event, state)"
					[options]="stateOverrideOptions"
					name="stateOverrideOptions"
					theme="dark"
				></bb-entity-selector> -->

				<bb-button icon="plus" [pxSize]="25" backgroundColor="blue" theme="dark" [round]="true" [matMenuTriggerFor]="addStateOptionMenu"></bb-button>
				<mat-menu #addStateOptionMenu="matMenu" class="dark-theme">
					<ng-container *ngFor="let menuItem of stateOverrideOptions">
						<div mat-menu-item (click)="onAddStateOptionSelected(menuItem, state)">
							<span>{{ menuItem.label }}</span>
						</div>
					</ng-container>
				</mat-menu>
			</div>
		</bb-collapsible>
		<div class="divider"></div>
	</ng-container>
</div>

<!-- TAGS -->
<div class="tags-wrapper">
	<div *ngIf="selectedWidget && selectedWidget.grouping && !selectedWidget.fromAppId" class="widget-tags">
		<ie-form-field [label]="'TAGS' | translate">
			<bb-entity-selector 
				[(ngModel)]="selectedWidgetTags"
				(ngModelChange)="onWidgetTagsChanged($event)"
				[multi]="true"
				[extendable]="true"
				[options]="allWidgetTags"
				name="widgetTags"
				theme="dark"
			></bb-entity-selector>
		</ie-form-field>
	</div>

	<div *ngIf="widgetSelection?.widgets?.length > 1" class="widget-tags">
		<ie-form-field [label]="'TAGS' | translate">
			<bb-entity-selector 
				[(ngModel)]="selectionGroupTags"
				(optionSelected)="onWidgetsTagAddedRemoved($event, false)"
				(optionRemoved)="onWidgetsTagAddedRemoved($event, true)"
				[partials]="selectionGroupTagsPartial"
				[multi]="true"
				[extendable]="true"
				[options]="allWidgetTags"
				name="widgetTags"
				theme="dark"
			></bb-entity-selector>
		</ie-form-field>
	</div>
</div>

<!-- TEMPLATES -->
<ng-template #dataSourceTemplate>
	<bb-data-source-picker
		*ngIf="dataSourceService.dataSourceModel !== undefined"
		[model]="dataSourceService.dataSourceModel"
		(ok)="dataSourceService.onDataSourceOk($event); onDataSourceChanged();"
		(remove)="dataSourceService.onDataSourceRemove($event); onDataSourceChanged();"
		(cancel)="dataSourceService.onDataSourceCancel($event)"
		(closed)="dataSourceService.onDataPickerClosed()"
	></bb-data-source-picker>
</ng-template>

<ng-template #itemField let-prop="prop" let-widget="widget" let-filterSet="filterSet" let-entityType="entityType">
	<div class="form-widget-field" *ngIf="mayRender(prop.key) || mayRender(widget?.type + '_' + prop.key)">
		<ie-form-field
			[label]="prop.label | translate"
			[useDataSource]="true"
			(dataSourceClicked)="onDataSourceClicked(prop.key)"
			[dataSourceActive]="widget?.config[prop.key]?.datasource"
		>
			<bb-entity-selector 
				*ngIf="!widget?.config[prop.key]?.datasource"
				[(ngModel)]="widget.config[prop.key]"
				[entityType]="entityType || 'commonclip'"
				(ngModelChange)="onFormFieldChanged(prop.key)"
				[filterSet]="filterSet"
				[name]="prop.key"
				theme="dark"
				[attr.data-cy]="'form-field-' + (prop.label | translate | lowercase)"
			></bb-entity-selector>
			<bb-entity-selector
				*ngIf="widget?.config[prop.key]?.datasource"
				[(ngModel)]="widget.config[prop.key].datasource.defaultValue"
				[entityType]="entityType || 'commonclip'"
				(ngModelChange)="onFormFieldChanged(prop.key)"
				[filterSet]="filterSet"
				[name]="prop.key"
				theme="dark"
			></bb-entity-selector>
		</ie-form-field>
	</div>
	<div class="display-value" *ngIf="collapsed && widget.config[prop.key]">
		{{ prop.label | translate }}
		<i class="fa fa-long-arrow-right"></i>
		{{ ({type: entityType || 'commonclip', value: (widget.config[prop.key]?.datasource?.defaultValue || widget.config[prop.key])} | entityLabel | async) || (widget.config[prop.key]?.datasource?.defaultValue || widget.config[prop.key]) }}
		<i class="fa fa-plug" *ngIf="widget.config[prop.key]?.datasource"></i>
	</div>
</ng-template>
